/** @typedef {'success' | 'warning' | 'error' | 'skip'} ValidationStatus */

/**
 * @typedef {Object} ValidationMessage
 * @property {'success' | 'warning' | 'error'} level
 * @property {string} message
 * @property {string} [developerNotes]
 */

/**
 * @typedef {Object} ValidationContext
 * @property {Object|null} patient
 * @property {Object|null} doctor
 * @property {*} transcription
 * @property {*} summarization
 * @property {*} trace
 * @property {{ transcription: string|null, summarization: string|null, trace: string|null, doctor: string|null }} fetchErrors
 * @property {boolean} isLoading
 */

/**
 * @typedef {Object} ValidationTestResult
 * @property {ValidationStatus} status
 * @property {ValidationMessage[]} messages
 * @property {string} [developerNotes]
 */

/**
 * @typedef {Object} ValidationTestDefinition
 * @property {string} id - Internal name (stable identifier)
 * @property {string} name - User-friendly label
 * @property {(ctx: ValidationContext) => ValidationTestResult | Promise<ValidationTestResult>} run
 */

/**
 * @typedef {Object} ValidationRunResult
 * @property {ValidationTestDefinition} test
 * @property {ValidationStatus} status
 * @property {ValidationMessage[]} messages
 * @property {string} [developerNotes]
 */

export const VALIDATION_STATUS = {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  SKIP: "skip",
};
